import { c as _c } from "react-compiler-runtime";
import React from "react";
import { TextField as AriaTextField } from "react-aria-components";
import { base } from "./TextField.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
const BaseTextField = (props, ref) => {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = /*#__PURE__*/_jsx(AriaTextField, {
      ...props,
      ref: ref,
      className: base
    });
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export const TextField = /*#__PURE__*/React.forwardRef(BaseTextField);
//# sourceMappingURL=TextField.js.map